/**
 * @desc 事件分析
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** baseCode */
  baseCode: string;
  /** baseId */
  baseId: string;
  /** factoryCode */
  factoryCode?: string;
  /** scope */
  scope: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.EventAnalysisResponse>>> {
  return defHttp.get({
    url: '/web/event/analysis',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<Array<defs.EventAnalysisResponse>>> {
  return defHttp.get({
    url: '/mock/web/event/analysis',

    params,
  });
}
